import React, { useState, useEffect } from "react";
import "../App.css";
import axios from "axios";
import Sidebar from "../componenteExtra/SidebarsocioGET";
import Modal from "react-modal";
import { Toaster } from "react-hot-toast";
import SessionManager from '../componenteExtra/SessionManager';

Modal.setAppElement("#root");

const VerSeniorGET = () => {
  const [seniorList, setSeniorList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedSenior, setSelectedSenior] = useState(null);
  const [approvalPendingActivities, setApprovalPendingActivities] = useState(
    [],
  );
  const [approvalPendingModalIsOpen, setApprovalPendingModalIsOpen] =
    useState(false);

  const token = localStorage.getItem("access_token");

  useEffect(() => {
    // Actualizar los conteos de actividades en espera de aprobación para los seniors
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/update_approval_pending_counts_senior`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        console.log(
          "Conteos de actividades en espera de aprobación actualizados:",
          response.data,
        );
        fetchSeniors(); // Llama a fetchSeniors para obtener la lista actualizada de seniors
      })
      .catch((error) =>
        console.error("Error al actualizar conteos de actividades:", error),
      );
  }, [token]);

  const fetchSeniors = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/get_all_seniors`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setSeniorList(response.data);
      })
      .catch((error) => console.error("Error fetching seniors:", error));
  };

  const openApprovalPendingModal = (seniorId) => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/activities_pending_approval_senior/${seniorId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        console.log(response.data); // Verifica si los datos están llegando aquí
        setApprovalPendingActivities(response.data);
        setSelectedSenior(seniorId);
        setApprovalPendingModalIsOpen(true);
      })
      .catch((error) =>
        console.error("Error fetching approval pending activities:", error),
      );
  };

  const closeApprovalPendingModal = () => {
    setApprovalPendingModalIsOpen(false);
    setApprovalPendingActivities([]);
  };

  const getRiskIndicatorColor = (fechaDocumentacion, fechaTermino) => {
    const today = new Date();
    const endDate = new Date(fechaTermino);

    const diffTime = endDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays >= 5) {
      return "green";
    } else if (diffDays > 3) {
      return "yellow";
    } else {
      return "red";
    }
  };

  return (
    <div className="app">
      <SessionManager />
      <Sidebar />
      <div className="main-content">
        <div className="main-panel">
          <h1>Ver todos los Seniors GET</h1>
          <div className="filter-section">
            <label htmlFor="searchTerm">Buscar por nombre del Senior: </label>
            <input
              type="text"
              id="searchTerm"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="activities-table-container">
            <table className="activities-table">
              <thead>
                <tr>
                  <th>Nombre Senior GET</th>
                  <th>Actividades en Espera de Aprobación</th>
                </tr>
              </thead>
              <tbody>
                {seniorList
                  .filter((senior) =>
                    senior.nombre_senior_get
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase()),
                  )
                  .map((senior, index) => (
                    <tr key={index}>
                      <td>{senior.nombre_senior_get}</td>
                      <td>
                        {senior.espera_aprobacion}
                        {senior.espera_aprobacion > 0 && (
                          <button
                            onClick={() => openApprovalPendingModal(senior.id)}
                            style={{
                              marginLeft: "10px",
                              backgroundColor: "yellow",
                              color: "black",
                            }}
                          >
                            Ver
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          {/* Modal para "Actividades en espera de aprobación" */}
          <Modal
            isOpen={approvalPendingModalIsOpen}
            onRequestClose={closeApprovalPendingModal}
            contentLabel="Actividades en espera de aprobación"
          >
            <h2>Actividades en espera de aprobación del Senior GET</h2>
            <button onClick={closeApprovalPendingModal}>Cerrar</button>
            <div className="activities-table-container">
              <table className="activities-table">
                <thead>
                  <tr>
                    <th>Código Proyecto</th>
                    <th>Razón Social</th>
                    <th>Filial</th>
                    <th>Socio de auditoría</th>
                    <th>Rubro GET</th>
                    <th>Nombre Actividad GET</th>
                    <th>Enlace Comentario</th>
                    <th>Staff Asignado</th>
                    <th>Fecha de Inicio - staff</th>
                    <th>Fecha de Término - staff</th>
                    <th>Horas Estándar</th>
                    <th>Fecha de Término de la Actividad</th>
                    <th>Riesgo</th>
                  </tr>
                </thead>
                <tbody>
                  {approvalPendingActivities.map((activity, index) => (
                    <tr key={index}>
                      <td>{activity.codigo_proyecto}</td>
                      <td>{activity.razon_social}</td>
                      <td>{activity.filial}</td>
                      <td>{activity.encargado_auditoria}</td>
                      <td>{activity.rubro_get}</td>
                      <td>{activity.nombre_actividad_get}</td>
                      <td>{activity.enlace_comentario}</td>
                      <td>{activity.staff_asignado}</td>
                      <td>{activity.fecha_de_inicio}</td>
                      <td>{activity.fecha_de_termino}</td>
                      <td>{activity.horas_estandar}</td>
                      <td>{activity.fecha_termino_senior_actividad}</td>
                      <td>
                        <div
                          style={{
                            width: "20px",
                            height: "20px",
                            borderRadius: "50%",
                            backgroundColor: getRiskIndicatorColor(
                              activity.fecha_documentacion_actividad,
                              activity.fecha_termino_senior_actividad,
                            ),
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Modal>
        </div>
      </div>
      <Toaster />
    </div>
  );
};

export default VerSeniorGET;
